import { Post, Get, Delete, Put } from "@/utils";
import { ApiPath } from "@/enums";
import dateUtils from "@/utils/date.utils";

export default {
  namespaced: true,
  actions: {
    async createCheckList({ }, request) {
      const { data: checklist } = await Post(
        `${ApiPath.Wioa}/createwioachecklist?type=0`,
        request,
        {
          transformRequest: [
            data => ({
              ...data,
              date: dateUtils.formatDateToISOString(data.date)
            }),
            ...axios.defaults.transformRequest
          ]
        }
      );
      return checklist;
    },
    async updateCheckList({ }, request) {
      const { data: checklist } = await Put(
        `${ApiPath.Wioa}/updatewioachecklist`,
        request,
        {
          transformRequest: [
            data => ({
              ...data,
              date: dateUtils.formatDateToISOString(data.date)
            }),
            ...axios.defaults.transformRequest
          ]
        }
      );
      return checklist;
    },
    async completeCheckList({ }, request) {
      const { data: checklist } = await Put(
        `${ApiPath.Wioa}/completewioachecklist?type=${request.type}`,
        request.checklist
      );
      return checklist;
    },
    async deleteChecklist({ }, checklistId) {
      const { data: checklist } = await Delete(
        `${ApiPath.Wioa}/deletewioachecklist?checklistId=${checklistId}`
      );
      return checklist;
    },
    async getCheckliStstatusByClient({ }, checklistRequestId) {
      const { data: checklistStatus } = await Get(
        `${ApiPath.Wioa}/getcheckliststatusbyclient?checklistRequestId=${checklistRequestId}`
      );
      return checklistStatus;
    },
    async getChecklistToReview({ }, checklistId) {
      const { data: checklistDetails } = await Get(
        `${ApiPath.Wioa}/getchecklisttoreviewbyclient?checklistId=${checklistId}`
      );
      return checklistDetails;
    },
    async generateUploadDocumentMetadata({ }, checklistId) {
      const { data: result } = await Get(
        `${ApiPath.Wioa}/generateuploaddocumentmetadata?checklistId=${checklistId}`
      );
      return result;
    },
    async hasChecklistRequest({ }, userId) {
      const { data: result } = await Get(
        `${ApiPath.Wioa}/haschecklistrequest?userId=${userId}`
      );
      return result;
    },
    async clientwioalist({}, clientwioalistrequest){
      const { data: result } = await Post(
        `${ApiPath.Wioa}/clientwioalist`,
        clientwioalistrequest
      );
      return result;
    },
    async validatePendingChecklistRequest({ }, request) {
      const { data: result } = await Post(
        `${ApiPath.Wioa}/validatependingchecklistrequest`,
        request
      );
      return result;
    },
    async getpendingchecklistrequest({ }, request) {
      debugger;
      const { data: result } = await Post(
        `${ApiPath.Wioa}/getpendingchecklistrequest?email=${request}`,
      );
      return result;
    },
  },
};
